jQuery(function ($) {
  "use strict";

  // outlinewp.smoothScrollAll();

  outlinewp.menuDropdown(".header__inner li.menu-item-has-children");
  outlinewp.mobileMenu(
    "#mobile__menu",
    "#mobile__menu--button",
    "#mobile__menu--screen"
  );
});



// WEBPACK FOOTER //
// ./resources/assets/scripts/app.js